export default "__VITE_ASSET__ec09bbf8__"